import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useSnackbar } from 'react-simple-snackbar'

import { CandidateContext } from '../../../../context/CandidateContext';
import { UserContext } from '../../../../context/userContext';
import { API } from '../../../../http-common';
import { GROUP } from "../../../../constants";
import { validateInputDni, sanitizeDniInput } from '../../../../hooks/ValidateInput';

const optionsError = {
    position: 'bottom-right',
    style: {
        backgroundColor: 'var(--bs-red)',
        border: '0',
        color: '#fff',
        fontSize: '20px',
        textAlign: 'center',
        marginBottom: '5rem',
    },
    closeStyle: {
        color: '#fff',
        fontSize: '16px',
        marginRight: '1rem',
    },
}

const optionsSuccess = {
    position: 'bottom-right',
    style: {
        backgroundColor: 'var(--bs-green)',
        border: '0',
        color: '#fff',
        fontSize: '20px',
        textAlign: 'center',
        marginBottom: '5rem',
    },
    closeStyle: {
        color: '#fff',
        fontSize: '16px',
        marginRight: '1rem',
    },
}

// TODO: "Agregar usuario principal" queda oculto hasta completar la implementación
// (documentos por padre secundario, permisos y validaciones). Pasar a true para habilitarlo.
const ADD_PARENT_ENABLED = false

/* onParentsChange se llama luego de agregar / quitar / cambiar el principal, para refrescar el resto del detalle */
export const ParentUserInfo = ({ onParentsChange }) => {
    const history = useHistory()
    const { candidateData, isSubUser } = useContext(CandidateContext)
    const { userData } = useContext(UserContext)

    const [openSnackbarSuccess] = useSnackbar(optionsSuccess)
    const [openSnackbarError] = useSnackbar(optionsError)

    const [parents, setParents] = useState(null)
    const [actionLoading, setActionLoading] = useState(false)

    const [addModalOpen, setAddModalOpen] = useState(false)
    const [newParentDocument, setNewParentDocument] = useState("")

    const canManageParents = GROUP.EQ_DIRECTORES.includes(userData.role_id)
    const canAddParent = ADD_PARENT_ENABLED && canManageParents

    const fetchParents = async (subId) => {
        try {
            const response = await API.get(`/prospects/sub-prospects/${subId}/documents`)
            setParents(response.data.data.parents || [])
        } catch (error) {
            openSnackbarError('Error al obtener los usuarios principales')
        }
    }

    useEffect(() => {
        if (candidateData?.id && isSubUser) {
            fetchParents(candidateData.id)
        } else {
            setParents(null)
        }
    }, [candidateData?.id, candidateData?.parent_prospect_id, isSubUser])

    const runParentAction = async (request, successMsg, errorMsg) => {
        setActionLoading(true)
        try {
            const response = await request()
            setParents(response.data.data.parents || [])
            openSnackbarSuccess(successMsg)
            onParentsChange?.()
            setActionLoading(false)
            return true
        } catch (error) {
            openSnackbarError(error.response?.data?.errors?.[0]?.msg || errorMsg)
            setActionLoading(false)
            return false
        }
    }

    const handleAddParent = async () => {
        const ok = await runParentAction(
            () => API.post(`/prospects/sub-prospects/${candidateData.id}/parents/${newParentDocument.trim()}`),
            'Usuario principal agregado correctamente',
            'Error al agregar el usuario principal'
        )
        if (ok) setAddModalOpen(false)
    }

    const handleRemoveParent = (parent) => {
        if (!window.confirm(`¿Quitar a ${parent.complete_name} como usuario principal?`)) return
        runParentAction(
            () => API.delete(`/prospects/sub-prospects/${candidateData.id}/parents/${parent.id}`),
            'Usuario principal quitado correctamente',
            'Error al quitar el usuario principal'
        )
    }

    const handleSetPrimary = (parent) => {
        runParentAction(
            () => API.post(`/prospects/sub-prospects/${candidateData.id}/parents/${parent.id}/primary`),
            'Usuario principal actualizado correctamente',
            'Error al cambiar el usuario principal'
        )
    }

    const handleViewParentUser = (parent) => {
        history.push({
            pathname: '/admin/details',
            search: '',
            state: { candidato_id: parent.id, is_balanz: candidateData.is_balanz }
        })
    }

    const handleOpenAddModal = () => {
        setNewParentDocument("")
        setAddModalOpen(true)
    }

    if (!isSubUser) {
        return null
    }

    return (
        <div className="col-md-12 item my-4" id="container_parent_user_info">
            <div className="container_history_here">
                <div className="car item_history">
                    <div className="card-body">
                        {canAddParent &&
                            <div className="d-flex justify-content-end mb-3">
                                <button
                                    type="button"
                                    className="btn blue_btn btn-sm"
                                    id="add_parent_user_btn"
                                    disabled={!parents || actionLoading}
                                    onClick={handleOpenAddModal}
                                >
                                    Agregar usuario principal
                                </button>
                            </div>
                        }
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Usuario principal</th>
                                    <th>DNI</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {parents ?
                                    parents.map((parent) => (
                                        <tr key={parent.id}>
                                            <td>
                                                {parent.complete_name}
                                                {parent.is_primary &&
                                                    <span className="badge bg-primary badge-primary ms-2">Principal</span>
                                                }
                                            </td>
                                            <td>{parent.document}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn blue_btn btn-sm me-2"
                                                    id={`view_parent_user_btn_${parent.id}`}
                                                    onClick={() => handleViewParentUser(parent)}
                                                >
                                                    Ver usuario principal
                                                </button>
                                                {canManageParents && !parent.is_primary &&
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="btn gray_btn btn-sm me-2"
                                                            id={`primary_parent_user_btn_${parent.id}`}
                                                            disabled={actionLoading}
                                                            onClick={() => handleSetPrimary(parent)}
                                                        >
                                                            Hacer principal
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn red_btn btn-sm"
                                                            id={`remove_parent_user_btn_${parent.id}`}
                                                            disabled={actionLoading}
                                                            onClick={() => handleRemoveParent(parent)}
                                                        >
                                                            Quitar
                                                        </button>
                                                    </>
                                                }
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <tr>
                                        <td colSpan={3}>Cargando datos de los usuarios principales...</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* AGREGAR USUARIO PRINCIPAL MODAL */}
            <Modal isOpen={addModalOpen} className="" id="add_parent_user_modal">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={() => setAddModalOpen(false)}>
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="modal-body">
                    <p className="modal_title blue_text">
                        Agregar usuario principal
                    </p>
                    <form action="#">
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="DNI del usuario principal"
                            inputMode="numeric"
                            maxLength={8}
                            value={newParentDocument}
                            onChange={e => setNewParentDocument(sanitizeDniInput(e.target.value))}
                        />
                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="add_parent_user_confirm_btn"
                                disabled={!validateInputDni(newParentDocument) || actionLoading}
                                onClick={handleAddParent}
                            >
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" id="add_parent_user_cancel_btn" onClick={() => setAddModalOpen(false)}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    )
}
